// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4536) return "static/chunks/4536-899040057661aa5f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "a74c11312a01df2e" + ".js";
};